<template>
    <div class="student_list_work">
        <el-dialog :title="title" width="50%" :visible.sync="dialogTableVisible" @close="closeDialog">
            <el-table :data="gridData">
                <el-table-column property="w_id_text" label="标题"></el-table-column>
                <el-table-column property="score" label="正确率" width="80"></el-table-column>
                <el-table-column property="signs" label="积分" width="80"></el-table-column>
                <el-table-column property="time" label="耗时" width="100"></el-table-column>
                <el-table-column property="createtime" label="做题时间" width="180"></el-table-column>
                <el-table-column width="100" label="操作">
                    <template slot-scope="scope">
                        <el-button
                        size="mini"
                        type="primary"
                        @click="handleStage(scope.row)">查看</el-button>
    
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin-top: 20px;"
                    hide-on-single-page
                    background
                    @size-change="changeSize"
                    @current-change="changeNumber"
                    @prev-click="prev"
                    @next-click="next"
                    :page-size="form_data.pageSize"
                    :current-page="form_data.page"
                    :total="total_number">
                </el-pagination>
                <Stage-work ref="stagework"></Stage-work>
        </el-dialog>
    </div>
</template>
<script>
import Http from "../src/apis/teach";
import stagework from "../untils/stagework";
export default {
    components:{
        'Stage-work':stagework
    },

    data(){
        return{
            dialogTableVisible:false,
            gridData:[],
            total_number:0,
            student_name:'',
            title:'',
            form_data:{
                level:'',
                uid:'',
                trem:'',
                page:1,
                pageSize:20,
                plan_id:'',
            }
        }
    },

    methods:{
        handleStage(item){
            this.dialogTableVisible = false
            if(item['table_type'] == 'specialty'){
                
                this.$router.push({name:'SpecialtyDetail',query:{id:item.w_id,type:item.type,student_id:item.u_id}});
            }else{
                this.$router.push({name:'ReadDetail',query:{id:item.w_id,student_id:item.u_id}});
            }
        },
        closeDialog(){
            this.dialogTableVisible = false
            this.form_data.page = 1
        },
        getStageWork_(uid, trem, level, name,plan_id){
            this.student_name = name
            this.form_data.uid = uid
            this.form_data.level = level
            this.form_data.trem = trem
            this.form_data.plan_id = plan_id
            
            this.title = `${trem}期 - ${level}层${name}做题记录`

            Http.stageSubmitList(this.form_data).then((res) => {
                this.dialogTableVisible = true
                this.gridData = res.data.list
                this.total_number = res.data.total_number
            });
        },
        // 上一页

        prev(e){

            this.form_data.page = e
            this.getStageWork_(this.form_data.uid,this.form_data.trem,this.form_data.level,this.student_name,this.form_data.plan_id)
        },

        // 下一页
        next(e){

            this.form_data.page = e
            this.getStageWork_(this.form_data.uid,this.form_data.trem,this.form_data.level,this.student_name,this.form_data.plan_id)
        },

        // 点击页码
        changeNumber(e){
            console.log(e)
            this.form_data.page = e
            this.getStageWork_(this.form_data.uid,this.form_data.trem,this.form_data.level,this.student_name,this.form_data.plan_id)
        },

        // 前往指定页数
        changeSize(e){

            this.form_data.page = e
            this.getStageWork_(this.form_data.uid,this.form_data.trem,this.form_data.level,this.student_name,this.form_data.plan_id)
        },
    }
}
</script>
<style scoped>
    .student_list_work >>> .el-dialog{
        border-radius: 8px;
        max-height: 90vh;
        overflow-y: auto;
        margin-top: 7vh !important;
    }
    .student_list_work >>> .el-dialog__header{
        text-align: left;
        font-weight: bold;
        font-size: 16px;
    }
</style>